import { createStyles, makeStyles } from "@material-ui/styles";
import { baseColors, RelodeTheme } from "@relode/core";

export const useClasses = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            form: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 0,
                flexBasis: "50%",
                marginLeft: "auto",
                marginRight: "auto",
            },
            step3Form: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 0,
                flexBasis: "80%",
                marginLeft: "auto",
                marginRight: "auto",
            },
            title: {
                fontSize: "20px",
                margin: theme.spacing(2, 0),
            },
            formField: {
                flex: "50%",
                margin: 0,
                "&:not(:first-child)": {
                    marginLeft: theme.spacing(3),
                },
            },
            textAreaField: {
                margin: 0,
            },
            section: {
                display: "flex",
                flexDirection: "column",
                marginBottom: theme.spacing(5),
            },
            sectionFields: {
                display: "flex",
                flexGrow: 1,
                flexDirection: "column",
                marginBottom: theme.spacing(2),
                [theme.breakpoints.up("md")]: {
                    flexDirection: "row",
                },
            },
            button: {
                marginBottom: theme.spacing(2),
            },

            label: {
                color: theme.relode.colors.label.main,
            },
            uploadLink: {
                margin: theme.spacing(2, 0),
                display: "inline-flex",
                color: theme.palette.primary.main,
                fontWeight: "bold",
                fontSize: "16px",
            },
            uploadIcon: {
                marginRight: theme.spacing(1),
            },
            uploadInput: {
                display: "none",
            },
            outlinedButton: {
                border: `1px solid ${baseColors.magenta}`,
                padding: 5,
            },
            asapButton: {
                minHeight: "71px",
                width: "120px",
                color: baseColors.black,
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_regular"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
                padding: 5,
            },
            fieldGroup: {
                display: "flex",
                flexDirection: "row",
            },
            selectableButtonsList: {
                paddingTop: "6px",
                paddingBottom: "7px",
            },
            sectionThreeContent: {
                display: "flex",
                flexDirection: "column",
                width: "100%",
            },
            removeMuiMargin: {
                margin: 0,
            },
            jobSalaryTypeButtons: {
                paddingTop: theme.spacing(1.25),
            },
        }),
    { name: "AddJobStep" }
);
